import { render, staticRenderFns } from "./PlatformIcon.vue?vue&type=template&id=5cae01fc&scoped=true"
import script from "./PlatformIcon.vue?vue&type=script&lang=js"
export * from "./PlatformIcon.vue?vue&type=script&lang=js"
import style0 from "./PlatformIcon.vue?vue&type=style&index=0&id=5cae01fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cae01fc",
  null
  
)

export default component.exports